module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Sun-d895f16997a244778623a5ad96eae74d.svg";